import React from 'react'
import { INFTSellModalYTSFeeProps } from '../models/INFTSellModal'
import { useGetCreatorFeeRate, useGetCreators } from '../../../../../hooks/useYetiSwapNFTCollection'
import { FeeWrapper } from '../styles/NFTSellModalFeeStyled'

export default function YTSNFTFee(props: INFTSellModalYTSFeeProps) {
  const { tokenId, commissionRate, account, price, tokenName } = props
  const tokenCreators = useGetCreators(tokenId)
  const tokenRoyalities = useGetCreatorFeeRate(tokenId)
  const parsedPrice = parseFloat(price)
  const sellPrice: number = !isNaN(parsedPrice) ? parsedPrice : 0

  function calculateRecive() {
    const serviceFee = (sellPrice * commissionRate) / 100
    let royalities = 0
    if (tokenCreators !== account && tokenRoyalities) {
      royalities = (sellPrice * tokenRoyalities) / 100
    }

    return sellPrice - serviceFee - royalities
  }
  return (
    <FeeWrapper>
      <div>Service Fee: {commissionRate}%</div>
      {tokenCreators !== account && tokenRoyalities ? <div>Royalties: {tokenRoyalities}%</div> : ''}
      <div>
        You will receive {calculateRecive()} {tokenName}
      </div>
    </FeeWrapper>
  )
}
